import {PAGE_HOTELS, PAGE_OFFERS} from '@/consts';

const scopeByPage = {
  [PAGE_HOTELS]: 'find-hotellist',
  [PAGE_OFFERS]: 'find-offerlist',
};

export const testId = (id: string) => {
  const currentPage = /hotel\/.+\/offers/.test(window.location.pathname)
    ? PAGE_OFFERS
    : PAGE_HOTELS;
  return `${scopeByPage[currentPage]}-${id}`;
};

export const sharedTestId = (id: string) => {
  return `shared-${id}`;
};
